// Shadcn 을 위해 Typescript 5 -> 4 로 다운그레이드하면서 toSpliced() 구현을 위해 대체한 스크립트.
declare global {
  interface Array<T> {
    toSpliced(start: number, deleteCount?: number, ...items: T[]): T[];
  }
}

if (!Array.prototype.toSpliced) {
  Array.prototype.toSpliced = function <T>(
    this: T[],
    start: number,
    deleteCount: number = 0,
    ...items: T[]
  ): T[] {
    const copy = [...this]; // 원본 배열 복사
    copy.splice(start, deleteCount, ...items); // 복사본에서 splice 적용
    return copy; // 수정된 복사본 반환
  };
}

export {};
